'use client';

import { useEffect, useRef } from 'react';

import styles from './HeaderLogo.module.scss';

const COLLAPSE_AT = 32;
const EXPAND_AT = 8;
const LOGO_WIDTH = 85;

export const HeaderLogo = () => {
  const logoRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const logo = logoRef.current;
    if (!logo) return;

    let collapsed = logo.dataset.collapsed === 'true';

    const setCollapsed = (nextCollapsed: boolean) => {
      if (collapsed === nextCollapsed) return;

      collapsed = nextCollapsed;
      logo.dataset.collapsed = String(nextCollapsed);
    };

    const update = () => {
      const y = window.scrollY;

      if (collapsed && y < EXPAND_AT) {
        setCollapsed(false);
      } else if (!collapsed && y > COLLAPSE_AT) {
        setCollapsed(true);
      }
    };

    update();
    window.addEventListener('scroll', update, { passive: true });

    return () => window.removeEventListener('scroll', update);
  }, []);

  return (
    <div ref={logoRef} className={styles.logo} data-collapsed="false">
      <svg
        width={LOGO_WIDTH}
        height={28}
        viewBox="0 0 86 28"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        className={styles.svg}
      >
        <path
          className={styles.fadeGlyph}
          d="M48.14 26.03H42.12L42.558 1.52L49.11 0L48.14 26.03Z"
        />
        <path
          className={styles.wGlyph}
          d="M25.74 5.44L20.96 26.02H14.207L12.61 17.17L10.551 26.02H4.2L0.2 11.39L6.77 9.86L8.06 18.62L9.89 9.13L15.26 7.88L17.23 18.76L18.47 7.14L25.74 5.44L25.74 5.44Z"
        />
        <path
          className={styles.fadeGlyph}
          d="M56.05 26.03H49.96L50.94 0.06L57.85 1.87L56.05 26.02L56.05 26.03Z"
        />
        <g className={styles.mark}>
          <path
            className={styles.markBar}
            d="M85.2 9.02L82.0 20.92H76.91L78.45 7.25L85.2 9.02H85.2Z"
          />
          <path
            className={styles.markDot}
            d="M81.58 25.12C81.58 26.712 80.28 28 78.69 28C77.09 28 75.8 26.709 75.8 25.12C75.8 23.53 77.09 22.24 78.69 22.24C80.28 22.24 81.58 23.53 81.58 25.12Z"
          />
        </g>
        <path
          className={styles.fadeGlyph}
          d="M33.061 8.16C26.12 8.84 24.95 15.0 24.95 17.73C24.95 20.78 27.16 26.06 32.768 26.06C37.52 26.06 38.93 24.8 38.93 24.8L39.04 19.7C39.04 19.7 37.81 21.29 34.75 21.7C31.84 22.1 31.1 19.74 31.1 19.74L40.44 18.65C40.44 18.65 42.25 7.27 33.061 8.17V8.16ZM35.34 15.78L31.02 16.38C31.02 16.38 31.646 13.596 33.5 13.596C35.36 13.596 35.34 15.78 35.34 15.78Z"
        />
        <path
          className={styles.fadeGlyph}
          d="M67.11 8.11C62.28 8.11 58.36 12.12 58.36 17.07C58.36 22.02 62.28 26.03 67.11 26.03C71.95 26.03 75.86 22.02 75.86 17.07C75.86 12.12 71.95 8.11 67.11 8.11ZM67.11 20.3C65.45 20.3 64.1 18.85 64.1 17.07C64.1 15.28 65.45 13.83 67.11 13.83C68.77 13.83 70.12 15.28 70.12 17.07C70.12 18.85 68.77 20.3 67.11 20.3Z"
        />
      </svg>
    </div>
  );
};
